var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8998 5.20711C13.6571 3.44975 16.5064 3.44975 18.2637 5.20711C20.0211 6.96447 20.0211 9.81371 18.2637 11.5711L12.2532 17.5314C12.0959 17.6886 11.8908 17.789 11.6701 17.8166L6.01326 18.5237C5.70705 18.5619 5.40032 18.4567 5.18211 18.2385C4.96391 18.0203 4.85867 17.7136 4.89694 17.4073L5.60405 11.7505C5.63163 11.5298 5.73198 11.3247 5.88922 11.1674L11.8998 5.20711ZM13.7029 6.30313L17.1677 9.76794C17.8108 8.79726 17.7048 7.47655 16.8495 6.62132C15.9943 5.76609 14.6736 5.66003 13.7029 6.30313ZM15.7889 11.2175L12.2533 7.68198L8.71765 11.1674L12.2532 14.703L15.7889 11.2175ZM10.6503 15.9285L7.49213 12.7703L7.04097 16.3796L10.6503 15.9285Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.82fb2a1e84dd64970ca6182d35fe5a1c.svg";
export { ForwardRef as ReactComponent };